<template>
  <div id="app">
    <main-section></main-section>
  </div>
</template>

<script>
import MainSection from './components/MainSection';

export default {
  name: 'app',
  components: {
    MainSection,
  },
};
</script>



// WEBPACK FOOTER //
// App.vue?790c4244